import { BaseParameterDto } from './base-parameter-dto';

export class UserProfileImageParameterDto extends BaseParameterDto {
  imageBase64: string;
}
